import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class SeriesImgs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { toggleOnIndex: 0 };
        // 这边绑定是必要的，这样 `this` 才能在回调函数中使用
        this.handleClick = this.handleClick.bind(this);
    }
    static propTypes = {
        content: PropTypes.object,
        seriesInfo: PropTypes.object,
    };

    handleClick(index) {
        this.setState(prevState => ({
            toggleOnIndex: index,
        }));
    }
    render() {
        const { content, seriesInfo } = this.props;

        return (
            <div>
                {content && seriesInfo && seriesInfo.standardName ? (
                    <div>
                        <div className={styles.arl_rs_tit}>
                            <h3>
                                <a
                                    target="_blank"
                                    rel={rel}
                                    title={seriesInfo.standardName}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/`}>
                                    {seriesInfo.standardName}
                                </a>
                            </h3>
                            <div className={styles.more}>
                                <a
                                    className={styles.red}
                                    title={`${seriesInfo.standardName}询最低价 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://auto.ifeng.com/xunjia/index.shtml?b=${content.brandId}&s=${
                                        content.serialId
                                    }`}>
                                    询最低价
                                </a>
                            </div>
                        </div>
                        <div className={styles.arl_c_det}>
                            <div className={styles.pic}>
                                <a
                                    className={styles.img}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://car.auto.ifeng.com/series/${content.serialId}/`}
                                    title={seriesInfo.standardName}>
                                    <img
                                        width="120"
                                        height="80"
                                        src={seriesInfo.serialLogo}
                                        alt={seriesInfo.standardName}
                                    />
                                </a>
                                <a
                                    className={styles.nb}
                                    title={`${seriesInfo.standardName}车系图片 `}
                                    target="_blank"
                                    rel={rel}
                                    href={`https://data.auto.ifeng.com/photo/s-${content.serialId}.html`}>
                                    共<span className={styles.red}>{seriesInfo.picCount}</span>张图片
                                </a>
                            </div>
                            <div className={styles.data}>
                                <div className={styles.data_item}>
                                    <label>指导价：</label>
                                    <a
                                        title={seriesInfo.standardName}
                                        href={`https://data.auto.ifeng.com/price/s-${content.serialId}.html`}
                                        target="_blank"
                                        rel={rel}>
                                        {seriesInfo.guidePrice}
                                    </a>万
                                </div>
                                <div className={styles.data_item}>
                                    <label>级　别：</label>
                                    {seriesInfo.level}
                                </div>
                                <div className={styles.data_item}>
                                    <label>发动机：</label>
                                    {seriesInfo.carExhaustVolume.map((item, index) => <span key={index}>{item}</span>)}
                                </div>
                                <div className={styles.data_item}>
                                    <label>变速箱：</label>
                                    {seriesInfo.biansuxiang.map((item, index) => <span key={index}>{item}</span>)}
                                </div>
                            </div>

                            <div
                                className={
                                    seriesInfo.outer && seriesInfo.inner ? styles.arl_car_pic : styles.arl_car_pic_hide
                                }>
                                <div className={styles.arl_car_pic_l}>
                                    <a
                                        target="_blank"
                                        rel={rel}
                                        href={`https://data.auto.ifeng.com/photo/pd-s-${
                                            content.serialId
                                        }-1-1.html#newsRightPicSerBy-${content.serialId}`}
                                        className={styles.img}>
                                        <img src={seriesInfo.outer} width="120" height="80" />
                                    </a>
                                    <h3>外观</h3>
                                </div>
                                <div className={styles.arl_car_pic_r}>
                                    <a
                                        target="_blank"
                                        rel={rel}
                                        href={`https://data.auto.ifeng.com/photo/pd-s-${
                                            content.serialId
                                        }-2-1.html#newsRightPicSerBy-${content.serialId}`}
                                        className={styles.img}>
                                        <img src={seriesInfo.inner} width="120" height="80" />
                                    </a>
                                    <h3>内饰</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(SeriesImgs);
